import { useReduxState } from 'hooks';
import { useApiData } from 'lib/api';
import { FormGroup, Select } from '.';

interface Props {
  maxWidth?: string;
  onlyIf?: boolean;
  title: string;
}

const AmbitionsSelector = ({ maxWidth, onlyIf = true, title }: Props) => {
  const {
    messages,
    pageState: { user }
  } = useReduxState();

  const { data } = useApiData({
    url: '/admin/ambitions',
    onlyIf: onlyIf && Boolean(user)
  });

  const options =
    data?.ambitions?.map((ambition: string) => ({
      label: ambition,
      value: ambition
    })) || [];

  return (
    <FormGroup label={title} maxWidth={maxWidth}>
      <Select
        creatable={true}
        field="ambitions"
        id="ambitions"
        isClearable={true}
        isMulti={true}
        isSearchable={true}
        noOptionsMessage={messages.settingsNoAmbitionsFound}
        options={options}
        placeholder={messages.settingsAddAmbition}
      />
    </FormGroup>
  );
};

export default AmbitionsSelector;
